import {
    Button,
    Divider,
    FormGroup,
    Input,
    Segment,
    SegmentContent,
} from '@/platform/ui';
import {
    MagnifyingGlassIcon,
    PlusIcon,
    TrashIcon,
} from '@heroicons/react/24/outline';

const EntitiesList = ({ entities, onChange, onModalOpen }) => {
    const handleEntityChange = (id, field, value) => {
        onChange(
            'entities',
            entities?.map(entity =>
                entity.id === id ? { ...entity, [field]: value } : entity
            )
        );
    };

    const handleEntityRemove = id => {
        onChange(
            'entities',
            entities?.filter(entity => entity.id !== id)
        );
    };

    const handleEntityAdd = () => {
        onChange('entities', [
            ...(entities || []),
            {
                id: `new-${Date.now()}`,
                name: '',
                kvk: '',
                lh: '',
                city: '',
            },
        ]);
    };

    return (
        <>
            <Divider content='Entiteiten' />

            {entities?.map(entity => (
                <Segment key={entity.id}>
                    <SegmentContent>
                        <FormGroup>
                            <Input
                                placeholder='Werkgever'
                                value={entity?.name || ''}
                                onChange={event =>
                                    handleEntityChange(
                                        entity.id,
                                        'name',
                                        event.target.value
                                    )
                                }
                            />
                            <Input
                                placeholder='KvK nummer'
                                value={entity?.kvk || ''}
                                onChange={event =>
                                    handleEntityChange(
                                        entity.id,
                                        'kvk',
                                        event.target.value
                                    )
                                }
                            />
                            <Input
                                placeholder='Loonheffingennummer'
                                value={entity?.lh || ''}
                                onChange={event =>
                                    handleEntityChange(
                                        entity.id,
                                        'lh',
                                        event.target.value
                                    )
                                }
                            />
                            <Input
                                placeholder='Plaats'
                                value={entity?.city || ''}
                                onChange={event =>
                                    handleEntityChange(
                                        entity.id,
                                        'city',
                                        event.target.value
                                    )
                                }
                            />
                        </FormGroup>

                        <div className='mt-4 flex justify-end'>
                            <Button
                                type='button'
                                variant='danger'
                                onClick={() => handleEntityRemove(entity.id)}
                            >
                                <TrashIcon className='size-4' />
                            </Button>
                        </div>
                    </SegmentContent>
                </Segment>
            ))}

            <div className='flex justify-end gap-2'>
                <Button type='button' onClick={handleEntityAdd}>
                    <PlusIcon className='size-4' />
                    Entiteit toevoegen
                </Button>
                <Button type='button' onClick={onModalOpen} variant='primary'>
                    <MagnifyingGlassIcon className='size-4' />
                </Button>
            </div>
        </>
    );
};

export default EntitiesList;
